import axiosInstance from "@/api/axiosInstance";
import { SendLoginInviteResponse } from "./types";

/**
 * Sends (or schedules) an Auth0 "set your password" login invite for an
 * employee. The API decides the exact behavior based on the employee's state
 * (already provisioned → sent now; role but unprovisioned → queued via sync).
 */
export const sendLoginInvite = async (
  employeeUuid: string,
): Promise<SendLoginInviteResponse> => {
  const response = await axiosInstance.post<SendLoginInviteResponse>(
    `/api/private/employees/${employeeUuid}/send-login-invite`,
  );
  return response.data;
};
